import React, { useContext, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { customStringify, error_alert, getToken, selectStylesField, setToken, stringNotEmpty, success_alert } from '../../../utils';
import { email_tl, enter_valid_number, less_than_100_tl, network_tl, positive_only_tl, required_tl } from '../../../translations';
import TextField from "../../../components/FormikFields/TextField";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { BasePopupContext } from '../../../hooks/usePopup';
import useApi from '../../../hooks/useApi';
import { BiLoader, BiLoaderAlt } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { login } from '../../../redux/slices/userSlice';
import { IoIosAddCircle } from 'react-icons/io';
import { HiOutlinePencil } from 'react-icons/hi2';
import SelectField from '../../../components/FormikFields/SelectField';
import { CATEGORIES, EMAIL_REGX, GENDERS, ROLE_INFLUENCER } from '../../../constants';
import DateField from '../../../components/FormikFields/DateField';
import { set_count } from '../../../redux/slices/influencerProfileSlice';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import CurrencyField from '../../../components/FormikFields/CurrencyField';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { useSearchParams } from 'react-router-dom';

const AddInfluencer = ({ data, refreshListing, }) => {
    console.log("data", data)
    const { closePopup } = useContext(BasePopupContext)
    const dispatch = useDispatch();
    const intl = useIntl();
    const [image, setImage] = useState(data ? data?.user?.picture : null);
    const [selectedPlatforms, setSelectedPlatforms] = useState(() => {
        const platforms = [];
        if (data?.instagram_name) platforms.push("instagram");
        if (data?.tiktok_name) platforms.push("tiktok");
        return platforms;
    });

    const [searchParams, setSearchParams] = useSearchParams();
    const create = searchParams.get('create');


    useEffect(() => {
        return () => {

            if (create) {
                searchParams.delete('create');
                setSearchParams(searchParams);

            }
        };
    }, [create, searchParams, setSearchParams]);



    const initialValues = {
        name: data ? data.user?.name : "",
        email: data ? data.user?.email : "",
        sur_name: data ? data.user?.sur_name : "",
        address: data ? data?.user?.address : "",
        place_id: data ? data?.user?.place_id : "",

        city: data ? data.user?.city : "",
        country: data ? data.user?.country : "",
        niches: data?.niches ? CATEGORIES.filter((item) => data.niches.includes(item.value)) : [],
        instagram_name: data ? data.instagram_name : "",
        instagram_bio: data ? data.instagram_bio : "",
        instagram_followers: data ? data.instagram_followers : "",
        instagram_engagement_metrics: data ? data.instagram_engagement_metrics : "",
        tiktok_name: data ? data.tiktok_name : "",
        tiktok_followers: data ? data.tiktok_followers : "",

        tiktok_engagement_metrics: data ? data.tiktok_engagement_metrics : "",
        date_of_birth: data ? data.date_of_birth : null,

        gender: data ? GENDERS.find((item) => item.value === data.gender) : "",
        average_price: data ? data.average_price : "",

        role: ROLE_INFLUENCER.value,
        selectedPlatforms: (() => {
            const platforms = [];
            if (data?.instagram_name) platforms.push("instagram");
            if (data?.tiktok_name) platforms.push("tiktok");
            return platforms;
        })(),
    }

    yup.addMethod(yup.string, "stringNotEmpty", stringNotEmpty);
    const validationSchema = yup.object({
        name: yup.string().stringNotEmpty(),
        email: yup.string().email(email_tl(intl)).required(required_tl(intl)).matches(EMAIL_REGX, email_tl(intl)),
        sur_name: yup.string().stringNotEmpty(),
        city: yup.string().stringNotEmpty(),
        address: yup.string().required(required_tl(intl)),
        country: yup.string().required(required_tl(intl)),
        niches: yup.array().min(1, required_tl(intl)).required(required_tl(intl)),
        instagram_name: selectedPlatforms?.includes('instagram') ? yup.string().required(required_tl(intl)) : yup.string().nullable(),
        instagram_followers: selectedPlatforms?.includes('instagram') ? yup.number().integer(enter_valid_number(intl)).typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).required(required_tl(intl)) : yup.number().nullable(),
        instagram_engagement_metrics: selectedPlatforms?.includes('instagram') ? yup.number().typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).max(100, less_than_100_tl(intl)).required(required_tl(intl)) : yup.number().nullable(),
        instagram_bio: selectedPlatforms?.includes('instagram') ? yup.string().required(required_tl(intl)) : yup.string().nullable(),

        tiktok_name: selectedPlatforms?.includes('tiktok') ? yup.string().required(required_tl(intl)) : yup.string().nullable(),
        tiktok_followers: selectedPlatforms?.includes('tiktok') ? yup.number().integer(enter_valid_number(intl)).typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).required(required_tl(intl)) : yup.number().nullable(),
        tiktok_engagement_metrics: selectedPlatforms?.includes('tiktok') ? yup.number().typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).max(100, less_than_100_tl(intl)).required(required_tl(intl)) : yup.number().nullable(),
        date_of_birth: yup.date().required(required_tl(intl)),
        selectedPlatforms: yup.array().min(1, intl.formatMessage({ id: "at_least_one_platform", defaultMessage: "At least one platform is required" })).required(required_tl(intl)),
        gender: yup.object().required(required_tl(intl)),
        average_price: yup.number().typeError(enter_valid_number(intl)).min(0, positive_only_tl(intl)).required(required_tl(intl)),

    })

    const { Axios } = useApi();

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(file);
            // setFormData((prev) => ({ ...prev, picture: file }));
        }
    };

    const handlePlatformSelect = (platform, form) => {
        setSelectedPlatforms((prev = []) => {
            const updatedPlatforms = prev?.includes(platform)
                ? prev?.filter((p) => p !== platform)
                : [...prev, platform];

            form.setFieldValue("selectedPlatforms", updatedPlatforms);
            return updatedPlatforms;
        });
    };
    const handleAddressSelect = (place, form) => {

        const terms = place.value.terms;
        const address = place?.label || "";

        console.log(address, "place");
        form.setFieldValue("address", address);

        let city = '';
        let country = '';

        terms.forEach((term, index) => {

            if (index === terms.length - 2) {
                city = term.value;
            }

            if (index === terms.length - 1) {
                country = term.value;
            }
        });

        form.setFieldValue('city', city);
        form.setFieldValue('country', country);
        form.setFieldValue('place_id', place.value.place_id);

        console.log('City:', city);
        console.log('Country:', country);
    };


    const handleSubmit = async (values, formikBag) => {
        let payload = {}

        data ?
            payload = {
                user: {
                    name: values.name,
                    sur_name: values.sur_name,
                    city: values.city,
                    country: values.country,
                    address: values.address,
                    place_id: values.place_id

                },
                gender: values.gender.value,
                average_price: values.average_price,
                niches: values.niches.map((item) => item.value),
                instagram_name: selectedPlatforms?.includes('instagram') ? values.instagram_name : null,
                instagram_bio: selectedPlatforms?.includes('instagram') ? values.instagram_bio : null,
                instagram_followers: selectedPlatforms?.includes('instagram') ? values.instagram_followers : null,
                instagram_engagement_metrics: selectedPlatforms?.includes('instagram') ? values.instagram_engagement_metrics : null,
                tiktok_name: selectedPlatforms?.includes('tiktok') ? values.tiktok_name : null,
                tiktok_followers: selectedPlatforms?.includes('tiktok') ? values.tiktok_followers : null,
                tiktok_engagement_metrics: selectedPlatforms?.includes('tiktok') ? values.tiktok_engagement_metrics : null,
                date_of_birth: values.date_of_birth

            }
            :
            payload = {
                name: values.name,
                email: values.email,
                sur_name: values.sur_name,
                city: values.city,
                address: values.address,
                place_id: values.place_id,
                country: values.country,
                role_code: values.role,
                influencer: {
                    gender: values.gender.value,
                    average_price: values.average_price,
                    niches: values.niches.length > 0 && values.niches.map((item) => item.value),
                    instagram_name: selectedPlatforms?.includes('instagram') ? values.instagram_name : null,
                    instagram_bio: selectedPlatforms?.includes('instagram') ? values.instagram_bio : null,
                    instagram_followers: selectedPlatforms?.includes('instagram') ? values.instagram_followers : null,
                    instagram_engagement_metrics: selectedPlatforms?.includes('instagram') ? values.instagram_engagement_metrics : null,
                    tiktok_name: selectedPlatforms?.includes('tiktok') ? values.tiktok_name : null,
                    tiktok_followers: selectedPlatforms?.includes('tiktok') ? values.tiktok_followers : null,
                    tiktok_engagement_metrics: selectedPlatforms?.includes('tiktok') ? values.tiktok_engagement_metrics : null,
                    date_of_birth: values.date_of_birth
                }
            }
        //   console.log("payload",payload)
        try {
            let response = {};
            if (image instanceof Blob || image instanceof File) {
                const PictureForm = new FormData();
                PictureForm.append("image", image);
                response = await Axios.post(`api/user/upload-image`, PictureForm);

                if (response.data?.payload) {
                    if (data) {
                        payload.user.picture = response.data?.payload?.file_path;
                    } else {
                        payload.picture = response.data?.payload?.file_path;
                    }
                }
            }
            let result = {}
            if (data) {
                result = await Axios.patch(`api/user/update-profile/influencer/${data.id}`, payload);
            } else {
                result = await Axios.post(`api/user/agency-influencer`, payload);

            }
            dispatch(set_count())
            success_alert(result.data.description)
            closePopup()
            refreshListing()
        } catch (e) {
            if (e.response) {
                error_alert(customStringify(e.response.data.description))
            } else {
                error_alert(network_tl(intl))
            }
            // closePopup()
        }
    }

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {
                    form => (
                        <Form>
                            <div className="flex justify-center items-center">
                                <div className="relative rounded-full flex items-center justify-center my-5">
                                    <img
                                        src={
                                            image
                                                ? typeof image === "string"
                                                    ? image
                                                    : URL.createObjectURL(image)
                                                : "/images/avatar.png"
                                        }
                                        alt="Profile"
                                        className="w-20 h-20 rounded-full object-cover border"
                                    />

                                    <label htmlFor="image-upload">
                                        {image ? (
                                            <div

                                                className="absolute -bottom-3 -right-2 rounded-full bg-primary p-2 "
                                            >
                                                <HiOutlinePencil className="text-xl text-white cursor-pointer" />
                                            </div>
                                        ) : (
                                            <IoIosAddCircle className="absolute -bottom-3 -right-2 cursor-pointer text-primary" size={40} />
                                        )}
                                    </label>
                                    <input
                                        id="image-upload"
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageUpload}
                                        className="hidden"
                                    />
                                </div>
                            </div>
                            <div className='mb-5 grid grid-cols-1 gap-5'>
                                <div>
                                    <TextField
                                        type="text"
                                        field="name"
                                        label_text={<FormattedMessage id="name" defaultMessage="Name" />}
                                        form={form}
                                        isRequired
                                    />
                                </div>
                                <div>
                                    <TextField
                                        type="text"
                                        field="sur_name"
                                        label_text={<FormattedMessage id="surname" defaultMessage="Surname" />}
                                        form={form}
                                        isRequired

                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        type="email"
                                        field="email"
                                        label_text={
                                            <FormattedMessage
                                                id="email"
                                                defaultMessage="email"
                                            />
                                        }
                                        form={form}
                                        isDisabled={data}
                                        isRequired

                                    />
                                </div>
                                <div>
                                    <DateField
                                        field="date_of_birth"
                                        label_text={<FormattedMessage id="date_of_birth" defaultMessage="Date of Birth" />}
                                        form={form}
                                        maxDate={new Date()}
                                        isRequired

                                    />
                                </div>
                                <div>
                                    <SelectField
                                        options={GENDERS}
                                        field="gender"
                                        label_text={<FormattedMessage id="gender" defaultMessage="Gener" />}
                                        form={form}
                                        isRequired

                                    />
                                </div>

                                {/* <div>
                                    <TextField
                                        type="text"
                                        field="city"
                                        label_text={<FormattedMessage id="city" defaultMessage="City" />}
                                        form={form}
                                        isRequired

                                    />
                                </div>
                                <div>
                                    <TextField
                                        type="text"
                                        field="country"
                                        label_text={<FormattedMessage id="country" defaultMessage="Country" />}
                                        form={form}
                                        isRequired

                                    />
                                </div> */}

                                <div>
                                    <label className='text-xs font-medium inline-block'>
                                        <FormattedMessage id="addrasdess*" defaultMessage="Addasdress*" />
                                    </label>
                                    <GooglePlacesAutocomplete
                                        apiKey={process.env.REACT_APP_PLACES_API_KEY}
                                        selectProps={{
                                            defaultValue: data?.user?.address
                                                ? {
                                                    label: data?.user?.address, // Display address
                                                    value: {
                                                        place_id: data?.user?.place_id, // Include place_id
                                                    },
                                                }
                                                : null,
                                            onChange: (place) => {

                                                handleAddressSelect(place, form)
                                            },
                                            placeholder: intl.formatMessage({ id: "address", defaultMessage: "Address" }),
                                            styles: selectStylesField(form.touched['address'] && form.errors['address']),
                                            filterOption: (option) => {
                                                console.log('option', option);
                                                // Filter out options where terms.length === 1
                                                return !(option?.data?.value?.terms && option?.data?.value?.terms?.length === 1);
                                            },
                                        }}
                                    />
                                    {form.errors.address && form.touched.address && (
                                        <p className="text-red-500 text-xs mt-1">{form.errors.address}</p>
                                    )}
                                </div>
                                <div>
                                    <CurrencyField
                                        type="text"
                                        field="average_price"
                                        label_text={<FormattedMessage id="average_price" defaultMessage="Average Price" />}
                                        form={form}
                                        isRequired

                                    />
                                </div>
                                <div>
                                    <SelectField
                                        options={CATEGORIES}
                                        field="niches"
                                        label_text={<FormattedMessage id="niches" defaultMessage="Niches" />}
                                        form={form}
                                        isMulti={true}
                                        isRequired

                                    />
                                </div>

                                <div className='w-full'>
                                    <label className='text-xs font-medium inline-block '><FormattedMessage id="platforms" defaultMessage={"Platforms"} /></label>
                                    <button
                                        type="button"
                                        onClick={() => handlePlatformSelect('instagram', form)}
                                        className={`w-full relative px-4 py-2 border-2 h-[45px] mt-1 rounded-md gap-x-2 flex items-center justify-center ${selectedPlatforms?.includes('instagram')
                                            ? 'border-primary text-white bg-primary'
                                            : form.errors.selectedPlatforms ? 'border-red-500'
                                                : 'border-gray-300'
                                            }`}
                                    >
                                        <FaInstagram className={`${selectedPlatforms?.includes('instagram') ? 'text-white' : 'text-pink-500'}`} size={26} />
                                        <FormattedMessage id="instagram" defaultMessage={"Instagram"} />
                                        {selectedPlatforms?.includes('instagram') && (
                                            <FaRegCircleCheck className="absolute top-[13px] right-2 text-white" />
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => handlePlatformSelect('tiktok', form)}
                                        className={`w-full relative px-4 py-2 border-2 h-[45px] mt-2 rounded-md flex gap-x-2 items-center justify-center ${selectedPlatforms?.includes('tiktok')
                                            ? 'border-primary text-white bg-primary'
                                            : form.errors.selectedPlatforms ? 'border-red-500'
                                                : 'border-gray-300'
                                            }`}
                                    >
                                        <FaTiktok className={`${selectedPlatforms?.includes('tiktok') ? 'text-white' : 'text-black'}`} size={26} />
                                        <FormattedMessage id="tiktok" defaultMessage={"Tiktok"} />
                                        {selectedPlatforms?.includes('tiktok') && (
                                            <FaRegCircleCheck className="absolute top-[13px] right-2 text-white" />

                                        )}
                                    </button>
                                    {
                                        (form.errors.selectedPlatforms || form.touched.selectedPlatforms) && (
                                            <p className="text-red-500 text-xs mt-1">{form.errors.selectedPlatforms}</p>
                                        )
                                    }
                                </div>


                                {/* Instagram Fields */}
                                {selectedPlatforms?.includes('instagram') && (
                                    <div className="gap-5 grid grid-cols-1  items-center ">
                                        <div>
                                            <TextField
                                                type="text"
                                                field="instagram_name"
                                                label_text={<FormattedMessage id="instagram_name" defaultMessage={"Instagram Name"} />}
                                                form={form}
                                                isRequired

                                            />
                                        </div>
                                        <div>
                                            <TextField
                                                type="text"
                                                field="instagram_bio"
                                                label_text={<FormattedMessage id="instagram_bio" defaultMessage={"Instagram Bio"} />}
                                                form={form}
                                                isRequired

                                            />
                                        </div>
                                        <div>
                                            <CurrencyField
                                                type="text"
                                                field="instagram_followers"
                                                label_text={<FormattedMessage id="instagram_followers" defaultMessage={"Instagram Followers"} />}
                                                form={form}
                                                isRequired

                                            />
                                        </div>
                                        <div>
                                            <TextField
                                                type="text"
                                                field="instagram_engagement_metrics"
                                                label_text={<FormattedMessage id="instagram_engagement_metrics" defaultMessage={"Instagram Engagement Rate"} />}
                                                form={form}
                                                isRequired

                                            />
                                        </div>
                                    </div>
                                )}

                                {/* TikTok Fields */}
                                {selectedPlatforms?.includes('tiktok') && (
                                    <div className="gap-5 grid grid-cols-1 items-center">
                                        <div>
                                            <TextField
                                                type="text"
                                                field="tiktok_name"
                                                label_text={<FormattedMessage id="tiktok_name" defaultMessage={"TikTok Name"} />}
                                                form={form}
                                                isRequired

                                            />
                                        </div>
                                        <div>
                                            <CurrencyField
                                                type="text"
                                                field="tiktok_followers"
                                                label_text={<FormattedMessage id="tiktok_followers" defaultMessage={"TikTok Followers"} />}
                                                form={form}
                                                isRequired

                                            />
                                        </div>
                                        <div>
                                            <TextField
                                                type="text"
                                                field="tiktok_engagement_metrics"
                                                label_text={<FormattedMessage id="tiktok_engagement_metrics" defaultMessage={"TikTok Engagement Rate"} />}
                                                form={form}
                                                isRequired

                                            />
                                        </div>
                                    </div>
                                )}




                            </div>
                            <div className="space-x-5 flex justify-end items-center">
                                <button
                                    disabled={form.isSubmitting}
                                    onClick={closePopup}
                                    type="button"
                                    className='!min-w-[120px] btn btn-secondary'
                                >
                                    <p className=''>
                                        {
                                            form.isSubmitting ?
                                                <div className='flex items-center justify-center'>
                                                    <BiLoaderAlt className="text-2xl animate-spin" />
                                                </div>
                                                :
                                                <FormattedMessage id="cancel" defaultMessage={"Cancel"} />
                                        }
                                    </p>
                                </button>
                                <button
                                    disabled={form.isSubmitting}
                                    type="submit"
                                    className='!min-w-[120px] btn btn-primary'
                                >
                                    <p>
                                        {
                                            form.isSubmitting ?
                                                <div className='flex items-center justify-center'>
                                                    <BiLoaderAlt className="text-2xl animate-spin" />
                                                </div>
                                                :
                                                <FormattedMessage id="Submit" defaultMessage={"Submit"} />
                                        }
                                    </p>
                                </button>

                            </div>
                        </Form>
                    )
                }

            </Formik>
        </>
    )
}

export default AddInfluencer